import React from "react";
import { Box, Typography, useTheme, Divider, Grid } from "@mui/material";
import SelectComponent from "../SelectComponent.js";

const FiltersPopup = ({ open, filters }) => {
  const theme = useTheme();
  const containerStyle = {
    backgroundColor: "#D0D5DE",
    color: "#717273",
    borderRadius: "10px",
    position: "fixed",
    right: "8px",
    top: 40,
    minWidth: "50vw",
    maxWidth: "80vw",
    overflow: "auto",
    zIndex: `${theme.zIndex.drawer + 1} !important`,
    px: 2,
  };
  return (
    open && (
      <Box sx={containerStyle}>
        <Typography sx={{ py: 0.5 }}>Filters</Typography>
        <Divider />
        <Grid container>
          {filters.map((f, index) => (
            <Box key={index} sx={{ display: "contents" }}>
              <Grid item xs={4} sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{f.selectLabel}:</Typography>
              </Grid>
              <Grid item xs={8}>
                <SelectComponent
                  key={f.selectLabel}
                  options={f.options}
                  value={f.value}
                  isMultiSelect={f.isMultiSelect}
                  required={f.required}
                  onChange={(value) => {
                    f.onChange(value);
                  }}
                  selectStyle={{
                    backgroundColor: "#D0D5DE",
                    width: "100%",
                    ".MuiOutlinedInput-notchedOutline": { border: "0px !important" },
                  }}
                ></SelectComponent>
              </Grid>
              {index !== filters.length - 1 && (
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              )}
            </Box>
          ))}
        </Grid>
      </Box>
    )
  );
};

export default FiltersPopup;
